String.prototype.hashCode = function () {
  let hash = 0;

  if (this.length === 0) return hash;
  for (let i = 0; i < this.length; i++) {
    const charCode = this.charCodeAt(i);
    hash = (hash << 5) - hash + charCode;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

String.prototype.isNumber = function () {
  return !Number.isNaN(this);
};

String.prototype.toNumber = function () {
  return Number(this);
};

String.prototype.testId = function () {
  return this.toLowerCase().replace(' - ', '-').replace(/ /g, '-').replace('.', '-');
};

Array.prototype.emptyJoin = function (separator: string) {
  return this.filter((value) => !!value).join(separator);
};

export {};
